/**
 * Auctionliner Cart Functions
 * Quick add to cart functionality integrated with Warehouse theme events
 */

(function() {
  'use strict';

  /**
   * Add product to cart via AJAX
   * @param {number} variantId - Shopify variant ID
   * @param {HTMLElement} button - Button element that triggered the action (optional)
   */
  window.AuctionlinerCart = window.AuctionlinerCart || {};

  window.AuctionlinerCart.addToCart = function(variantId, button) {
    // Add loading state to button if provided
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
      button.style.opacity = '0.6';
      button.style.cursor = 'wait';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }
      return response.json();
    })
    .then(function(data) {
      // Dispatch product:added event to trigger theme's cart refresh
      // This will update the mini-cart, cart count, and show notification
      // As documented in assets/custom.js
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: data,
          quantity: 1
        }
      }));

      // Remove loading state
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.style.opacity = '';
        button.style.cursor = '';
      }
    })
    .catch(function(error) {
      console.error('Error adding to cart:', error);

      // Show error notification
      if (window.theme && typeof window.theme.showNotification === 'function') {
        window.theme.showNotification('Error adding to cart. Please try again.', 'error');
      } else {
        alert('Error adding to cart. Please try again.');
      }

      // Remove loading state
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.style.opacity = '';
        button.style.cursor = '';
      }
    });
  };

  // Alias for backward compatibility
  window.addToCart = window.AuctionlinerCart.addToCart;

})();
